module.exports = __webpack_public_path__ + "img/th.dc229fc3.png";